"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcActionDropdown = void 0;
var react_1 = __importDefault(require("react"));
var FaIcon_1 = require("../util/FaIcon");
var AcDropdown_1 = require("./AcDropdown");
var AcActionDropdown = function (props) {
    var _a = props.icon, icon = _a === void 0 ? 'fas fa-exclamation-mark' : _a, rest = __rest(props, ["icon"]);
    return (react_1.default.createElement(AcDropdown_1.AcDropdown, __assign({ disableDropdownIcon: true, title: react_1.default.createElement(FaIcon_1.FaIcon, { icon: icon, fixedWidth: true, size: "big" }) }, rest)));
};
exports.AcActionDropdown = AcActionDropdown;
exports.AcActionDropdown.displayName = 'AcActionDropdown';
//# sourceMappingURL=AcActionDropdown.js.map